export const getRecaptchaSiteKey = () => {
  const origin = window.location.origin;

  let siteKey;

  if (origin.includes("spdevmfp") || origin.includes("localhost")) {
    siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY_DEV;
  } else if (origin.includes("sppreprod") || origin.includes("sptestmfp")) {
    siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY_PREPROD;
  } else {
    siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY_PROD;
  }

  if (!siteKey) {
    console.error('reCAPTCHA site key not found in environment variables for environment:', origin);
    throw new Error('reCAPTCHA site key not configured');
  }

  return siteKey;
};
